import React, { useEffect, useState } from 'react';

type TabProps = {
  onChange: (item: number) => void;
  selectedTabIndex: number;
  tabs: any[];
  appointmentsCount?: undefined;
};
export const Tabs = ({ onChange, selectedTabIndex, tabs, appointmentsCount }: TabProps) => {
  const [selectedIndex, setSelectedIndex] = useState<number>(1);
  useEffect(() => {
    setSelectedIndex(selectedTabIndex);
  }, []);
  const onTabClicked = (index: number) => {
    setSelectedIndex(index);
    onChange(index);
  };
  return (
    <>
      <div className="tab-bg">
        {tabs.map((tab, index) => (
          <>
            {tab.show && (
              <div
                className={`tab-item ${index == selectedIndex ? 'active' : ''}`}
                onClick={() => onTabClicked(index)}
              >
                {tab && tab?.label}
                {/* {tab?.label == 'Accepted' && (
                <div className="pet-badge-rounded">{appointmentsCount?.accepted}</div>
              )} */}
              </div>
            )}
            {tab.show && index < tabs.length - 1 && <div className="menu-divider"></div>}
          </>
        ))}
      </div>
    </>
  );
};
